module.exports = __webpack_public_path__ + "static/media/download_sidebar.1a6ca18c.svg";